import { gql } from '@parkchirp/api-client';

export const LIST_VEHICLE_TYPES = gql`
  query listVehicleTypes(
    $organizationId: Int!
    $order: SortOrder
    $filters: [Filter]
    $limit: Int
    $offset: Int
    $report: String
  ) {
    listVehicleTypes(
      organizationId: $organizationId
      order: $order
      filters: $filters
      limit: $limit
      offset: $offset
      report: $report
    ) {
      data {
        id
        name
      }
      total
      url
    }
  }
`;

export const LIST_VEHICLE_TYPE_ASSIGNMENTS = gql`
  query listVehicleTypeAssignments(
    $organizationId: Int!
    $order: SortOrder
    $filters: [Filter]
    $limit: Int!
    $offset: Int!
    $report: String
  ) {
    listVehicleTypeAssignments(
      organizationId: $organizationId
      order: $order
      filters: $filters
      limit: $limit
      offset: $offset
      report: $report
    ) {
      data {
        make
        makeId
        model
        modelId
        types {
          type
          typeId
        }
      }
      total
      url
    }
  }
`;
